<template>
  <div>
    <div class="l-container">

      <h1 class="m-label">指導報告書</h1>
      <tr-c slot="tr-th">
        <th-c>id</th-c>
        <th-c>student_tutor_id</th-c>
        <th-c>user_id</th-c>
        <th-c>month</th-c>
        <th-c>filing_date</th-c>
        <th-c>note</th-c>
        <th-c>作成日</th-c>
        <th-c>更新日</th-c>
      </tr-c>
      <tr-c slot="tr-td">
        <td-c>{{report.id}}</td-c>
        <td-c>{{report.student_tutor_id}}</td-c>
        <td-c>{{report.user_id}}</td-c>
        <td-c>{{report.month}}</td-c>
        <td-c>{{report.filing_date}}</td-c>
        <td-c>{{report.note}}</td-c>
        <td-c>{{report.created_at}}</td-c>
        <td-c>{{report.updated_at}}</td-c>
      </tr-c>

    </div>

    <template v-if="report.id">
      <iframe v-bind:src="files + report.id + '_r.pdf'" frameborder="0"></iframe>
    </template>

  </div>
</template>

<script>
import { getFILE } from '@/store/getters.js'
const files = getFILE()

export default {
  computed: {
    report () {
      return this.$store.getters.report
    }
  },
  data () {
    return {
      files: files
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getReport(to.params.id)
    })
  },
  methods: {
    getReport (id) {
      this.$store.dispatch('getReport', {
        id: id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 231px);
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// Report.vue?3fe6be5f